import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideo2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="video-2, camera, movie, play"><path d="M2.75 5.25H17.25V18.75H2.75V5.25Z" stroke="currentColor" strokeWidth="1.5"/><path d="M17.25 9L21.75 7V17L17.25 15" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconVideo2;
